module.exports = __webpack_public_path__ + "img/strava-logo.504d435f.jpg";